import { usePermissions } from "ra-core";
import { Navigate } from "react-router";

/** /parametres index: admins land on Utilisateurs, reps on Mon profil (spec 10 §5.10). */
export const ParametresRedirect = () => {
  const { permissions, isPending } = usePermissions();
  if (isPending) return null;
  return (
    <Navigate
      to={permissions === "admin" ? "/parametres/utilisateurs" : "/profile"}
      replace
    />
  );
};
